export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6270.f4b9a077.jpg";